@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'account.back-button-text' | translate }}</p>
    </div>
  </div>
}

<div class="page-name">
  <h3>{{ 'change-iban.title' | translate }}</h3>
</div>

<div class="block">
  @if (currentIbanLastFour) {
    <div class="row">
      <div class="title">
        <p class="subtitle-14">{{ 'change-iban.current-iban-title' | translate }}</p>
      </div>
      <div class="current-value">
        <p class="body-16">•••• •••• •••• •••• •••• {{ currentIbanLastFour }}</p>
      </div>
    </div>
  }

  <div class="row">
    <div class="title">
      <p class="subtitle-14">{{ 'change-iban.new-iban-title' | translate }}</p>
    </div>

    <div class="input">
      <input
        class="input"
        type="text"
        placeholder="{{ 'change-iban.new-iban-placeholder' | translate }}"
        [(ngModel)]="newIban"
        (input)="formatIban($event)"
        maxlength="40"
        />
    </div>
  </div>

  <div class="row">
    @for (error of errors; track error) {
      <div class="error">
        <p class="body-12 error">{{ error | translate }}</p>
      </div>
    }
  </div>

  <div class="row info-section">
    <div class="info-item">
      <p class="body-12 info-text">{{ 'change-iban.info.format' | translate }}</p>
    </div>
    <div class="info-item">
      <p class="body-12 info-text">{{ 'change-iban.info.example' | translate }}</p>
    </div>
  </div>
</div>

<div class="flex-placeholder"></div>

<div class="actions">
  <button class="button secondary" (click)="navigateBack()">
    {{ 'change-iban.cancel-button' | translate }}
  </button>

  <button class="button primary" (click)="saveChanges()">
    {{ 'change-iban.save-button' | translate }}
  </button>
</div>
